import "can/construct/";
import "can/view/stache/";
import "dragAndDrop";
import SearchVM from "src/help-pages/help-page-search";
// import es from "src/locale/help-pages/es.json!system-json";
// import fr from "src/locale/help-pages/fr.json!system-json";


export default can.Construct.extend({
    create: function( params ) {
        "use strict";

        // if ( typeof es[ params.helpDir ] !== "undefined" && typeof es[ params.helpDir ][ params.helpComponent ] !== "undefined" ) {
        //     Locale.additionalTranslations.es = es[ params.helpDir ][ params.helpComponent ];
        // }

        // if ( typeof fr[ params.helpDir ] !== "undefined" && typeof fr[ params.helpDir ][ params.helpComponent ] ) {
        //     Locale.additionalTranslations.fr = fr[ params.helpDir ][ params.helpComponent ];
        // }

        let title = "GUIDE TO THE " + params.helpComponent.toUpperCase().replace( /\-/g, " " ) + " PAGE",
            helpStache = `src/help-pages/${params.helpDir}/${params.helpComponent}/help-page.stache`;

        BootstrapDialog.show({
            title: Locale.translate( title ),
            size: "size-wide",
            draggable: true,
            closeByBackdrop: false,

            message: can.view( helpStache ),

            onshow: dialog => {
                Vistracks.HelperUtils.modal.setHeight( dialog );

                let resizeId,
                    modalHeaderHeight = dialog.$modalHeader.outerHeight(),
                    searchVM = new SearchVM();

                searchVM.attr("dialog", dialog );

                dialog.$modalHeader.after( can.view( "src/help-pages/help-page-search.stache", searchVM ) );

                $( window )
                    .resize(function() {
                        clearTimeout( resizeId );
                        resizeId = setTimeout(function() {
                            Vistracks.HelperUtils.modal.setHeight( dialog );
                        }, 20 );
                    });

                dialog.$modalContent.resizable({
                    minHeight: 300,
                    minWidth: 300,
                    resize: function( event, ui ) {
                        dialog.$modalBody.css( "height", ui.size.height - modalHeaderHeight );

                        // Set Closable from true to false because it will close the dialog when cursor is on the backdrop
                        dialog.setClosable( false );
                    },
                    stop: function() {
                        setTimeout(function() {
                            dialog.setClosable( true );
                        }, 100 );
                    }
                });

            },

            onshown: function() {
                VtAdmin.Modules.set( $(".help-page-search-container"), [ "input" ]);
            },

            onhidden: function( dialog ) {
                dialog.$modalContent.resizable( "destroy" );
            },

            buttons: [
                {
                    label: Locale.translate("Search"),
                    cssClass: "btn btn-link waves-effect",
                    action: dialog => {

                        $(".help-page-search-container").slideToggle( 300, function(){
                            if ( $(".help-page-search-container").is(":visible") ) {
                                $("#help-page-search-term").focus();
                                Vistracks.HelperUtils.modal.setHeight( dialog, $( window ).height() - 180 - $(".help-page-search-container").height() );
                            } else {
                                $("#help-page-search-term").val("");
                                Vistracks.HelperUtils.modal.setHeight( dialog );
                            }
                        });

                    }
                }, {
                    label: Locale.translate("Close"),
                    cssClass: "btn btn-link waves-effect",
                    action: dialog => dialog.close()
                }
            ]
        });
    }
});
